import ErrorPage from 'components/ui/ErrorPage';
import FirstScreen from 'components/ui/firstTimeScreen/firstScreen';
import { CreateUserForm } from 'pages/Users/CreateUserForm';
import { Users } from 'pages/Users';
import { ROUTES } from './routes';
import { MODULE_BY_SETTING } from './settings.config';
import App from 'pages/App';
import { DataTables } from 'pages/DataTables';
import { Home } from 'pages/Home';
import Organizations from 'pages/Organizations';
import { Products } from 'pages/Products';
import { createBrowserRouter } from 'react-router-dom';
import { CreateProductForm } from 'pages/Products/CreateProductForm';
import NewOrganization from 'pages/Organizations/NewOrganization';
import EditRoles from 'pages/Roles/EditRoles';
import { Roles } from 'pages/Roles';
import { EditProcessMap } from 'components/ui/processMap/canvas/EditProcessMap';
import { EditDataCaptureForm } from 'components/ui/dataCapture/EditDataCaptureForm';
import { ProcessBlock } from 'components/ui/processMap/processBlock';
import { DataCaptureFormsListView } from 'pages/DataCapture';
import { Reports } from 'pages/Reports';
import { Dashboard } from 'pages/Dashboard';
import ProtectedRoute from 'components/ui/ProtectedRoute';
import { UnitsOfMeasure } from 'pages/UnitsOfMeasure';
import { UploadHistory } from 'pages/UploadHistory';
import { DataSourceFields } from 'pages/DataSources/DataSourceFields';
import { DataSources } from 'pages/DataSources';
import { ControlDocuments } from 'pages/ControlDocuments';
import { ErrorDetails } from 'pages/ErrorDetails';
import {
  CreateProcessMapForm,
  ProcessMapArchivedListView,
  ProcessMapListView,
} from 'pages/ProcessMaps';

export const router = createBrowserRouter([
  {
    path: ROUTES.ROOT,
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      // Public Routes
      {
        path: ROUTES.HOME,
        element: <Home />,
      },
      {
        path: ROUTES.ENROLL_NOW,
      },
      {
        path: ROUTES.FIRST_SCREEN,
        element: <FirstScreen />,
      },

      // Organizations Routes (Protected by Organizations module)
      {
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.ORGANIZATIONS} />
        ),
        children: [
          {
            path: ROUTES.ORGANIZATIONS.LIST,
            element: <Organizations />,
          },
          {
            path: ROUTES.ORGANIZATIONS.CREATE,
            element: <NewOrganization />,
          },
          {
            path: ROUTES.ORGANIZATIONS.EDIT,
            element: <NewOrganization formAction="edit" />,
          },
        ],
      },

      // DATA_APPROVE (protected separately)
      {
        path: ROUTES.DATA.APPROVE,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.ORGANIZATIONS}>
            <Organizations />
          </ProtectedRoute>
        ),
      },

      // Users Routes (Protected by Users module)
      {
        element: <ProtectedRoute moduleName={MODULE_BY_SETTING.USERS} />,
        children: [
          {
            path: ROUTES.USERS.LIST,
            element: <Users />,
          },
          {
            path: ROUTES.USERS.VIEW,
            element: <CreateUserForm formAction="view" />,
          },
          {
            path: ROUTES.USERS.EDIT,
            element: <CreateUserForm formAction="edit" />,
          },
          {
            path: ROUTES.USERS.CREATE,
            element: <CreateUserForm />,
          },
        ],
      },

      // Process Maps Routes (Protected by ProcessMaps module)
      {
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.PROCESSES_MAP} />
        ),
        children: [
          {
            path: ROUTES.PROCESSES.MAPS.MAP.EDIT,
            element: <EditProcessMap />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.MAP.VIEW,
            element: <EditProcessMap />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.MAP.BLOCK.EDIT,
            element: <ProcessBlock />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.MAP.BLOCK.VIEW,
            element: <ProcessBlock />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.LIST,
            element: <ProcessMapListView />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.CREATE,
            element: <CreateProcessMapForm />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.ARCHIVED,
            element: <ProcessMapArchivedListView />,
          },
          {
            path: ROUTES.PROCESSES.MAPS.MAP.CONFIG,
            element: <CreateProcessMapForm formAction="edit" />,
          },
        ],
      },

      // Data Sources Route (Protected by DataSources module)
      {
        element: <ProtectedRoute moduleName={MODULE_BY_SETTING.DATA_SOURCES} />,
        children: [
          {
            path: ROUTES.DATA_SOURCES.LIST,
            element: <DataSources />,
          },
          {
            path: ROUTES.DATA_SOURCES.EDIT,
            element: <DataSourceFields />,
          },
        ],
      },

      // Products Routes (Protected by Products module)
      {
        element: <ProtectedRoute moduleName={MODULE_BY_SETTING.PRODUCTS} />,
        children: [
          {
            path: ROUTES.PRODUCTS.LIST,
            element: <Products />,
          },
          {
            path: ROUTES.PRODUCTS.CREATE,
            element: <CreateProductForm />,
          },
          {
            path: ROUTES.PRODUCTS.VIEW,
            element: <CreateProductForm formAction="view" />,
          },
          {
            path: ROUTES.PRODUCTS.EDIT,
            element: <CreateProductForm formAction="edit" />,
          },
        ],
      },

      // Data Tables Route (Protected by DataTables module)
      {
        path: ROUTES.DATA.TABLES,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.DATA_TABLES}>
            <DataTables />
          </ProtectedRoute>
        ),
      },

      // Roles Routes (Protected by RoleManagement module)
      {
        path: ROUTES.ROLES.LIST,
        element: <ProtectedRoute moduleName={MODULE_BY_SETTING.ROLES} />,
        children: [
          {
            index: true,
            element: <Roles />,
          },
          {
            path: ROUTES.ROLES.VIEW,
            element: <EditRoles />,
          },
          {
            path: ROUTES.ROLES.EDIT,
            element: <EditRoles />,
          },
          {
            path: ROUTES.ROLES.DUPLICATE,
            element: <EditRoles />,
          },
        ],
      },

      // Data Capture Forms Routes (Protected by Forms module)
      {
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.DATA_CAPTURE_FORMS} />
        ),
        children: [
          {
            path: ROUTES.DATA.CAPTURE_FORMS.LIST,
            element: <DataCaptureFormsListView />,
          },
          {
            path: ROUTES.DATA.CAPTURE_FORMS.EDIT,
            element: <EditDataCaptureForm />,
          },
          {
            path: ROUTES.DATA.CAPTURE_FORMS.VIEW,
            element: <EditDataCaptureForm formAction="view" />,
          },
        ],
      },

      // Reports Route (Protected by ReportingAndAnalytics module)
      {
        path: ROUTES.REPORTS,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.REPORTS}>
            <Reports />
          </ProtectedRoute>
        ),
      },

      // Dashboard Route (Protected by ReportingAndAnalytics module)
      {
        path: ROUTES.DASHBOARD,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.REPORTS}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },

      // Units of Measure Route (By now protected by SiteManagement module)
      {
        path: ROUTES.UNITS_OF_MEASURE,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.UNITS_OF_MEASURE}>
            <UnitsOfMeasure />
          </ProtectedRoute>
        ),
      },

      // Upload History Route (By now protected by SiteManagement module)
      {
        path: ROUTES.UPLOAD_HISTORY,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.UPLOAD_HISTORY}>
            <UploadHistory />
          </ProtectedRoute>
        ),
      },

      // Error Details Route (By now protected by SiteManagement module)
      {
        path: ROUTES.ERROR_DETAILS.LIST,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.UPLOAD_HISTORY}>
            <ErrorDetails />
          </ProtectedRoute>
        ),
      },

      // Control Documents Route (By now protected by SiteManagement module)
      {
        path: ROUTES.CONTROL_DOCUMENTS,
        element: (
          <ProtectedRoute moduleName={MODULE_BY_SETTING.CONTROL_DOCUMENTS}>
            <ControlDocuments />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
